import { render } from "./controller-realtime-data.vue?vue&type=template&id=49e9754b&ts=true"
import script from "./controller-realtime-data.vue?vue&type=script&lang=ts"
export * from "./controller-realtime-data.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__